import { useTranslation } from 'react-i18next';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { useSignInRedirect } from '@/hooks/useSignInRedirect';

import { SignupForm } from '@/components/forms/authForms/signupForm/SignupForm';

import { LoginWrapper } from './LoginWrapper';

const Signup = () => {
  useSignInRedirect();

  const { t } = useTranslation();

  useDocumentTitle(t('landing.signup.pageTitle'));

  return (
    <LoginWrapper>
      <SignupForm />
    </LoginWrapper>
  );
};

export default Signup;
